var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { Slider } from "../generic/range-slider/Slider";
import { ResourceTradeInfo } from "./ResourceTradeInfo";
var TradeComponent = /** @class */ (function (_super) {
    __extends(TradeComponent, _super);
    function TradeComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.getTradeResourcesInfo = function () {
            var _a = _this.props, wastedResourceInfo = _a.wastedResourceInfo, wastedResourceAmount = _a.wastedResourceAmount, purchasedResourceInfo = _a.purchasedResourceInfo, purchasedResourceAmount = _a.purchasedResourceAmount, backgroundStyle = _a.backgroundStyle;
            var boughtResourceAmountInfo = __assign({}, purchasedResourceInfo, { amount: Long.fromValue(purchasedResourceAmount) });
            var wastedResourceAmountInfo = __assign({}, wastedResourceInfo, { amount: Long.fromValue(wastedResourceAmount) });
            if (wastedResourceInfo != undefined && purchasedResourceInfo != undefined) {
                return (React.createElement(ResourceTradeInfo, { wastedResourceInfo: wastedResourceAmountInfo, purchasedResourceInfo: boughtResourceAmountInfo, backgroundStyle: backgroundStyle }));
            }
            return undefined;
        };
        _this.getTradeInput = function () {
            var _a = _this.props, wastedResourceMinAmount = _a.wastedResourceMinAmount, wastedResourceMaxAmount = _a.wastedResourceMaxAmount, sliderValue = _a.sliderValue;
            return (React.createElement(Slider, { minValue: wastedResourceMinAmount, maxValue: wastedResourceMaxAmount, value: sliderValue, step: 1, onSliderChange: _this.onSliderChange }));
        };
        _this.onSliderChange = function (value) {
            _this.props.onSliderChange(value);
        };
        return _this;
    }
    TradeComponent.prototype.render = function () {
        var tradeResourcesInfo = this.getTradeResourcesInfo();
        var tradeInput = this.getTradeInput();
        return (React.createElement(React.Fragment, null,
            tradeResourcesInfo,
            tradeInput));
    };
    return TradeComponent;
}(React.Component));
export { TradeComponent };



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/TradeComponent.tsx
// module id = 605
// module chunks = 3